const clientLogos = [
  {
    image: require("./img/clientlogos/logo-axel.png"),
    url: "https://www.axelsa.com.ar/",
    alt: "Electrodomesticos AXEL",
  },
  {
    image: require("./img/clientlogos/liliana.jpg"),
    url: "",
    alt: "Liliana Electrodomésticos",
  },
  {
    image: require("./img/clientlogos/josetroyano.png"),
    url: "https://josetroyano.com.ar/",
    alt: "Jose Troyano",
  },
  {
    image: require("./img/clientlogos/texel.png"),
    url: "",
    alt: "TEXEL Equipos Electromédicos",
  },
  {
    image: require("./img/clientlogos/tornomar.png"),
    url: "",
    alt: "Tornomar",
  },
  {
    image: require("./img/clientlogos/jarama.png"),
    url: "",
    alt: "Jarama",
  },
  {
    image: require("./img/clientlogos/saldivia_s.png"),
    url: "https://saldiviabuses.com.ar/",
    alt: "Saldivia",
  },
  {
    image: require("./img/clientlogos/strada.png"),
    url: "https://www.strada.com.ar/",
    alt: "Strada",
  },
  {
    image: require("./img/clientlogos/trinivision.png"),
    url: "https://trini.com.ar/",
    alt: "Trinivision",
  },
  {
    image: require("./img/clientlogos/vic.png"),
    url: "https://vic-sa.com.ar/",
    alt: "VIC Luces",
  },
];

export default clientLogos;
